// extracted by mini-css-extract-plugin
export default {"dialog-create-shiftplan__datepicker":"dialog-create-shiftplan__datepicker--e0Te8","dialogCreateShiftplanDatepicker":"dialog-create-shiftplan__datepicker--e0Te8"};